module.exports = "/_next/static/pages/about/Fragments/20a77ccee228ca0360365ba6a9fb5772.jpg";